
import icon from '../../assets/icons/logoCios.svg'; // Asegúrate de ajustar la ruta a la ubicación correcta de tu imagen
import React from 'react'



export const IconoCios = () => {
    return (
        <div>
            <img src={icon} alt="Icon" style={{ width: '35px', height: '35px', color: 'gray' }} />
        </div>
    )
}
